var _g, _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDollar = function SvgDollar(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 768,
    height: 768,
    viewBox: "0 0 768 768",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M345.6 72.96c0 33.024-2.304 42.24-11.52 42.24-19.2 0-67.584 27.648-89.856 51.456-26.112 27.648-36.864 56.064-36.864 98.304 0 80.64 40.704 122.112 169.728 173.568 62.976 24.576 83.712 42.24 83.712 71.424 0 52.992-65.28 73.728-136.704 43.008-21.504-9.216-43.776-21.504-48.384-27.648s-14.592-10.752-22.272-10.752c-14.592 0-53.76 51.456-53.76 71.424 0 21.504 68.352 61.44 136.704 79.104 5.376 1.536 9.216 16.896 9.216 41.472v38.4h83.712l2.304-39.936c2.304-36.096 3.84-39.936 24.576-45.312 31.488-8.448 68.352-36.096 89.088-66.816 19.2-26.88 29.184-97.536 19.968-135.168-11.52-45.312-62.208-82.944-162.048-120.576-79.872-29.952-108.288-71.424-72.96-106.752 31.488-31.488 92.16-29.952 144.384 3.072 17.664 10.752 35.328 19.968 39.936 19.968 3.84 0 16.896-17.664 27.648-39.936l20.736-39.936-24.576-20.736c-20.736-16.896-43.008-26.112-98.304-42.24-6.144-1.536-9.984-16.896-9.984-41.472v-38.4h-84.48v42.24z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDollar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dollar.b3b7d639.svg";
export { ForwardRef as ReactComponent };